/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNotNullUri: core.serialization.ObjectSchema<serializers.IsNotNullUri.Raw, Truvity.IsNotNullUri> =
    core.serialization.object({});

export declare namespace IsNotNullUri {
    export interface Raw {}
}
